import React from "react";
import { Outlet } from "react-router-dom";

function NoAuth() {
  return <Outlet />;
}

export default NoAuth;
